<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template #activator="{ on }">
      <v-btn color="primary" dark class="elevation-0" v-on="on">Создать новый</v-btn>
    </template>

    <v-card :loading="isLoading">
      <v-card-title>Новый элемент</v-card-title>
      <v-card-text>
        <v-container>
          <layer-form
            v-model="form"
            :icon-list="iconList"
            :lock-object-type="lockObjectType"
            :lock-category="lockCategory"
            :except="except"
            :category-list="categoryList"
            @submit="onCreate"
          />
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import LayerForm from '@/components/page/layers/forms/LayerForm.vue';
import moment from 'moment';

const createDefaultForm = () => ({
  name: null,
  categoryId: null,
  iconId: null,
  mapType: null,
  objectType: 'event',
  formId: null,
});

export default {
  // Создание слоев нужно вынести в другой компонент, а не хранить все в layer-form.
  // Так ка у них единственное общее это передача onsubmit. и пара компонентов,
  name: 'new-layer-dialog',
  components: { LayerForm },
  props: {
    parentId: String,
    lockObjectType: String,
    lockCategory: String,
    happenedAt: String,
    except: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    dialog: false,
    form: createDefaultForm(),
    isLoading: false,
  }),
  computed: {
    ...mapState('icons', { iconList: 'list' }),
    ...mapState('categories', { categoryList: 'fullList' }),
  },
  watch: {
    // не понятно при каком условии у нас может обновится данное окно
    dialog: 'updateModal',
  },
  methods: {
    ...mapActions('icons', {
      getIconsList: 'getList',
    }),
    ...mapActions('categories', {
      getCategoriesList: 'getFullList',
    }),
    ...mapActions('layer-objects', ['create']),
    ...mapActions(['showNotify']),

    async onCreate(data) {
      this.isLoading = true;

      try {
        const params = {
          ...data,
          parentId: this.parentId,
        };

        if (this.happenedAt) {
          params.happenedAt = moment(this.happenedAt, 'DD.MM.YYYY HH:mm').format();
        }

        const { id, name } = await this.create(params);
        this.showNotify({ message: `Слой "${name}" успешно создан` });
        this.$router.push({ name: 'layers-item', params: { id } });
      } catch (e) {
        this.showNotify({ type: 'error', mesage: 'При создании слоя произошла ошибка. Обратитесь к администратору' });
      }

      this.isLoading = false;
    },

    async updateModal() {
      this.form = createDefaultForm();

      this.isLoading = true;
      await this.getIconsList();
      await this.getCategoriesList();
      this.isLoading = false;
    },
  },
};
</script>
